import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// Styles
import "./index.scss";
import "./controls.css";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.css";

ReactDOM.render(<App />, document.getElementById("root"));
